import { Component, Input, OnInit } from '@angular/core';
import { Trial } from 'src/app/_model/trial';

@Component({
  selector: 'app-trials',
  templateUrl: './trials.component.html',
  styleUrls: ['./trials.component.scss']
})
export class TrialsComponent implements OnInit {
  @Input() trials: Trial[];
  constructor() { }

  ngOnInit(): void {
    console.log('trials', this.trials)
  }

}
